export const getters = {
    getSecaoProduto: state => state.secaoProduto,
    getSecoesProduto: state => state.secoesProduto,
    getModalCadastroSecaoProduto: state => state.modalCadastroSecaoProduto,
    getModalExcluirSecaoProduto: state => state.modalExcluirSecaoProduto
}

export default {}